import { setCurrency } from 'utils/utils'

export const TABLE_ORDER_DETAIL = {
    name: '',
    column: [
        {
            name: 'Product',
            key: 'orderId',
            render: ({ item }) => (
                <div className={'flex flex-row items-center space-x-4'}>
                    <img src={item?.image_url} alt={'product-image'} className={'border w-12 h-12'} />
                    <p>{item?.name}</p>
                </div>
            ),
        },
        {
            name: 'Quantity',
            key: 'quantity',
            render: ({ value }) => <p>{value} Pcs</p>,
        },
        {
            name: 'Price',
            render: ({ item }) => (
                <>
                    {item?.sale_total !== item?.total ? (
                        <div className={'flex flex-col space-y-2'}>
                            <p>{setCurrency(item?.sale_total)}</p>
                            <p className={'line-through'}>{setCurrency(item?.total)}</p>
                        </div>
                    ) : (
                        <p>{setCurrency(item?.total)}</p>
                    )}
                </>
            ),
        },
    ],
}
